import React from "react";
import "./Blogs.css";
import Solar_Insights from "../home/solar-insights/Solar_Insights";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faUser } from "@fortawesome/free-solid-svg-icons";
import { Blog } from "../../utils/apis/blog/Blog";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/common";
import RedHeading from "../common/common_title/red-heading/RedHeading";
import ExperiencePower from "../gallary_showcase/experience_power/ExperiencePower";
import HaveQuestion from "../effects_page/category_tabs/fire/have_question/HaveQuestion";

const Blogs = () => {
  const navigate = useNavigate();
  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 2,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 3,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 4,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 5,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Solar Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential solar systems help homeowners reduce electricity bills, increase property value, and...",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [blog, setBlog] = useState([]);

  const firstThree = blog.slice(0, 3);
  const restBlogs = blog.slice(3);

  const getBlog = async () => {
    const res = await Blog();

    if (res?.success) {
      setBlog(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBlog();
  }, []);

  return (
    <>
      <section className="Blogs-page-section ">
        <RedHeading
          title="Explore Our Latest Blogs"
          subtitle="See the Magic in Action"
          className="title-h"
        />
        <div className="container">
          <div className="Solar_Insights_header_holder"></div>
          {/* <div className="blog_grid">
            {blog.map((blog) => (
              <div
                key={blog.id}
                className={`blog_card ${
                  blog.id <= 2 ? "blog_card_large" : "blog_card_small"
                }`}
                style={{
                  backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                }}
                onClick={() => handleServiceClick(blog.id)}
              >
                <div className="blog_overlay">
                  <div className="blog_meta">
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                    <span className="author_name">{blog.name}</span>
                    <span className="date">
                      -{" "}
                      {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <h3 className="blog_title">{blog.title}</h3>
                  <p className="blog_desc">
                    {htmlToReactParser.parse(blog.description)}
                  </p>

                  <a href="#" className="read_more">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div> */}
          <div className="blog_grid">
            {firstThree?.map((item) => (
              <div
                key={item.id}
                className="blog_card_new"
                onClick={() => handleServiceClick(item.id)}
              >
                {/* IMAGE */}
                <div className="blog_img">
                  <img src={`${IDS?.IMG_URL}${item?.image}`} alt={item?.name} />
                </div>

                {/* CONTENT */}
                <div className="blog_content">
                  <div className="title-wrapper">
                    <h4 className="title">{item?.name}</h4>
                    <div className="red-btn">
                      <div className="arrow-btn">
                        <FontAwesomeIcon icon={faAngleRight} />
                      </div>
                    </div>
                  </div>{" "}
                  <p className="date">
                    {new Date(item.createdAt).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                  <p className="desc">
                    {htmlToReactParser.parse(item?.description)}
                  </p>
                  <p className="desc">
                    {htmlToReactParser.parse(item?.conclusion)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="ExperiencePower-wrapper">
          {" "}
          <ExperiencePower />
        </div>


        
         <div className="container">
          <div className="blog_grid">
            {restBlogs?.map((item) => (
              <div
                key={item.id}
                className="blog_card_new"
                onClick={() => handleServiceClick(item.id)}
              >
                {/* IMAGE */}
                <div className="blog_img">
                  <img src={`${IDS?.IMG_URL}${item?.image}`} alt={item?.name} />
                </div>

                {/* CONTENT */}
                <div className="blog_content">
                  <div className="title-wrapper">
                    <h4 className="title">{item?.name}</h4>
                    <div className="red-btn">
                      <div className="arrow-btn">
                        <FontAwesomeIcon icon={faAngleRight} />
                      </div>
                    </div>
                  </div>{" "}
                  <p className="date">
                    {new Date(item?.createdAt).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                  <p className="desc">
                    {htmlToReactParser.parse(item?.description)}
                  </p>
                  <p className="desc">
                    {htmlToReactParser.parse(item?.conclusion)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div> 
        <HaveQuestion />
      </section>
    </>
  );
};

export default Blogs;
